import { MusicNoteIdentity } from "../../../wasm/pkg/wasm";
import { buildNotesAscendingFromNoteId } from "../../models/wasm.model";

export function isStringInstrument(it: InstrumentType) {
  return true; // ../someday change
}

export type InstrumentType = "Guit6" | "Uke4"; // | 'Banjo5' | ...

export const ALL_INSTRUMENT_TYPES: Array<InstrumentType> = ["Guit6", "Uke4"];

export const INSTR_TYPE_NAMES: Record<InstrumentType, string> = {
  Guit6: "Guitar (6 string)",
  Uke4: "Ukulele",
};

const HIGHEST_VISIBLE_FRET = 16;

export function buildDefaultGuitarTuning6String(): StringsTuning {
  const notesLowToHigh = ["E", "A", "D", "G", "B", "E"] as Array<MusicNoteIdentity>;
  return buildStringsTuning(notesLowToHigh);
}

export function buildDefaultUkeleleTuning4String(): StringsTuning {
  const notesLowToHigh = ["G", "C", "E", "A"] as Array<MusicNoteIdentity>;
  return buildStringsTuning(notesLowToHigh);
}

export function buildDefaultTuningForInstrument(instrumentType: InstrumentType) {
  if (instrumentType === "Uke4") {
    return buildDefaultUkeleleTuning4String();
  }
  return buildDefaultGuitarTuning6String();
}

export function buildStringsTuning(rootNotesLowToHigh: Array<MusicNoteIdentity>): StringsTuning {
  return {
    stringsLowToHigh: rootNotesLowToHigh.map((id) => buildNotesAscendingFromNoteId(id, HIGHEST_VISIBLE_FRET)),
  };
}
export function retuneString(tuning: StringsTuning, index: number, newRoot: MusicNoteIdentity): StringsTuning {
  const newTuning = JSON.parse(JSON.stringify(tuning)) as StringsTuning;
  newTuning.stringsLowToHigh[index] = buildNotesAscendingFromNoteId(newRoot, HIGHEST_VISIBLE_FRET);
  return newTuning;
}

export type StringsTuning = {
  // notesHighToLow: Array<MusicNoteIdentity>;
  stringsLowToHigh: Array<Array<MusicNoteIdentity>>;
};

export type TablatureSingleChord = {
  stringFretsLowToHigh: Array<number | "x">;
};

// The mashup turns out to be more harm than good
// export type ChordTablature = {
//   chord: ChordInScaleEdit;
//   tuning: StringsTuning;
//   fretsHighToLow: Array<number | 'x'>;
// };
